export const generateLanguagesDropdownOptions = (languagesList, emptySelectionLabel) => {
	const generatedLanguagesList = languagesList.map(language => ({
		id: language.id,
		label: language.name,
	}));
	return emptySelectionLabel ? [{ id: null, label: emptySelectionLabel }, ...generatedLanguagesList] : generatedLanguagesList;
};